const CSV_HEADERS = [
    "Name",
    "Mobile",
    "Email",
    "Location",
    "Checked in at",
    "Checked in by",
    "Notes",
];
function csvCell(value) {
    if (/[",\r\n]/.test(value))
        return `"${value.replace(/"/g, '""')}"`;
    return value;
}
function formatCheckedInAt(iso) {
    if (!iso)
        return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return iso;
    return d.toISOString();
}
export function buildAttendanceCsv(rows) {
    const lines = [
        CSV_HEADERS.join(","),
        ...rows.map((row) => [
            csvCell(row.name),
            csvCell(row.mobile ?? ""),
            csvCell(row.email ?? ""),
            csvCell(row.location ?? ""),
            csvCell(formatCheckedInAt(row.checkedInAt)),
            csvCell(row.checkedInByName ?? ""),
            csvCell(row.notes ?? ""),
        ].join(",")),
    ];
    return `\uFEFF${lines.join("\r\n")}\r\n`;
}
export function attendanceCsvFilename(eventTitle, at = new Date()) {
    const day = at.toISOString().slice(0, 10);
    const slug = eventTitle
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .slice(0, 48);
    return `attendance-${day}${slug ? `-${slug}` : ""}.csv`;
}
//# sourceMappingURL=attendance-report.js.map